import { WebService, WebServiceMultipart } from './webServices';

export const setAccessTokenToHeader = (token) => {
  // const token = 'md.akhil@panorbit.in';
  if (token) {
    WebService.defaults.headers.Authorization = `${token}`;
    WebServiceMultipart.defaults.headers.Authorization = `${token}`;
  } else {
    delete WebService.defaults.headers.Authorization;
    delete WebServiceMultipart.defaults.headers.Authorization;
  }
};

export const setCustomHeader = (key, value) => {
  if (value) {
    WebService.defaults.headers.common[key] = `${value}`;
    WebServiceMultipart.defaults.headers.common[key] = `${value}`;
  } else {
    delete WebService.defaults.headers.common[key];
    delete WebServiceMultipart.defaults.headers.common[key];
  }
};
